import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { SlackIntegrationConfig } from '@dadohr/shared/domainTypes/integrations/slack';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import {
  callFirebaseFunction,
  useFirebaseFunction
} from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { ONE_MINUTE, now } from '../../../../../../services/time';

export const toSlackConfigDoc = generateToDocFn<SlackIntegrationConfig>();

export const slackConfigStore = createDocumentListenerGetter(
  (orgId) => store().collection(FS.slackIntegrationConfig).doc(orgId),
  toSlackConfigDoc
);

export const useSlackConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(slackConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<SlackIntegrationConfig> = {
          id: orgId,
          collection: FS.slackIntegrationConfig,
          data: {
            orgId,
            active: false,
            botUserOAuthAccessToken: '',
            installationId: '',
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export type SlackChannel = { id: string; name: string; isPrivate: boolean };

export const getSlackChannelList = (orgId: string) => {
  return callFirebaseFunction<SlackChannel[]>(
    'integrations_slack-getChannelList',
    {
      orgId
    }
  );
};

export const useSlackChannelList = (orgId: string) => {
  return useFirebaseFunction<SlackChannel[]>(
    'integrations_slack-getChannelList',
    {
      orgId
    },
    [orgId],
    ONE_MINUTE / 30
  );
};
